module.exports = __webpack_public_path__ + "img/Formosa 1867_6.f4464dc0.jpg";